<template>
    <div name="ranking-banner" class="banner">
        <span class="title">1형 당뇨인 <span style="color: var(--Blue-01_Primary-blue, #008DEF)">불편접수함</span></span>
        <span class="description" style="margin-top: 8px;">
            1형 당뇨인과 가족들이 ‘불편함’을 느낀 순간을<br>
            솔닥 컨시어지는 그냥 지나치지 않습니다.  <br><br>
            지금 떠오르는 불편함이 있다면 알려주세요.<br>
            <span style="font-weight: 700;">해결할 수 있는 방법을 함께 찾고,<br> 
            행동으로 바꿔나가겠습니다.</span>
        </span>
        <div class="button" style="margin-top: 20px;"
            @click="postUncomfortable"
        >불편 접수하기 →</div>
        <span class="info" style="margin-top: 8px;">* 비속어나 권리 침해 게시물 방지를 위해<br>회원 로그인 후 작성이 가능합니다.</span>
        <img style="z-index: 0;" src="../../../assets/m_ranking_banner.png" />
        <div class="fixed-bar" v-if="isFixedBarView">
            <span class="text2">📬 1형 당뇨인 불편접수함</span>
            <div class="button2" @click="postUncomfortable">불편 접수하기 →</div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'rankingBanner',
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    data: function()
    {
        return {
            isFixedBarView: false,
            scrollY: 0
        }
    },
    methods: {
        postUncomfortable: function()
        {
            this.$emit('postUncomfortable')
        },
        handleScroll() {
            this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
            
            if(this.scrollY > 460)
            {
                this.isFixedBarView = true;
            }
            else
            {
                this.isFixedBarView = false
            }
        }
    }
}
</script>

<style scoped>
    .banner {
        position: relative;
        width: 100%;
        padding: 55px 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        background: linear-gradient(90deg, rgba(192, 212, 237, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%);
    }

    img {
        width: 317.413px;
        position: absolute;
        right: 20px;
        bottom: 60px;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    }
    .description {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
        z-index: 1;
    }

    .button {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: #1D4A94;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 142.857% */
        width: 125px;
        cursor: pointer;
        padding: 16px 0;
        z-index: 2;
    }
    .info {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .fixed-bar {
        display: flex;
        position: fixed;
        top: 56px;
        left: 0;
        width: 100%;
        height: 56px;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
        padding: 0 20px 0 32px;
        z-index: 3;
    }
    .text2 {
        color: var(--Blue-01_Primary-blue, #008DEF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .button2{
        display: flex;
        width: 125px;
        height: 34px;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: #1D4A94;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        cursor: pointer;
    }

</style>


// WEBPACK FOOTER //
// src/components/organisms/m_uncomfortable/RankingBanner.vue